import Vue from 'vue'
import QuestionDescription from './src/Question/QuestionDescription.vue'
import QuestionTitle from './src/Question/QuestionTitle.vue'
import QuestionAttributes from './src/Question/QuestionAttributes.vue'
import Field from './src/Question/Fields/Field.vue'
import CheckBoxField from './src/Question/Fields/CheckBoxField.vue'
import NumberField from './src/Question/Fields/NumberField.vue'
import RadioField from './src/Question/Fields/RadioField.vue'
import RangeField from './src/Question/Fields/RangeField.vue'
import StringField from './src/Question/Fields/StringField.vue'
import TextField from './src/Question/Fields/TextField.vue'
import FieldSelector from './src/Wrappers/FieldSelector.vue'
import SurveyHeader from './src/Wrappers/SurveyHeader.vue'
import ThankYouPage from './src/Wrappers/ThankYouPage.vue'

export default {
 install(Vue, options) {
  // Let's register our component globally
  // https://vuejs.org/v2/guide/components-registration.html
  Vue.component('question-attributes', QuestionAttributes)
  Vue.component('question-description', QuestionDescription)
  Vue.component('question-title', QuestionTitle)
  Vue.component('survey-field', Field)
  Vue.component('checkbox-field', CheckBoxField)
  Vue.component('number-field', NumberField)
  Vue.component('radio-field', RadioField)
  Vue.component('range-field', RangeField)
  Vue.component('string-field', StringField)
  Vue.component('text-field', TextField)
  Vue.component('field-selector', FieldSelector)
  Vue.component('survey-header', SurveyHeader)
  Vue.component('thank-you-page', ThankYouPage)
 }
};